'use strict';

require('../utils/mathTruncPolyfill');

const Moment = require('moment');

const flatpickr = require('flatpickr').default;
import { French } from 'flatpickr/dist/l10n/fr';

import { ConditionallyDisplayedElement } from './conditionallyDisplayedElement';
import { Dropdown } from './dropdown';

import { executeRecaptcha } from '../utils/executeRecaptcha';
import { isAdultPerson } from '../utils/isAdultPerson';

export function Form(params) {
    const formElement = params.element;
    const useDefaultSubmit = params.useDefaultSubmit;
    const submitCTAElements = formElement.querySelectorAll('[type=submit]');
    const loadingCtaModifier = 'cta--loading';

    let dropdowns = [];


    function initDateInputs() {
        const inputElements = formElement.querySelectorAll('[type=date]:not([noinit])');
        const today = new Date();
        const todayFullYear = today.getFullYear();
        today.setFullYear(todayFullYear);
        const defaultMaxDate = new Date(today);

        for (let i = 0; i < inputElements.length; i++) {
            inputElements[i].setAttribute('type', 'text');

            const options = {
                disableMobile: true,
                locale: French,
                dateFormat: 'd/m/Y',
                allowInput: true
            };

            const moment = Moment(inputElements[i].value);
            if (moment.isValid()) {
                if (inputElements[i].name.indexOf('Birthdate') > -1) {
                    if (!isAdultPerson(inputElements[i].value)) {
                        options['defaultDate'] = defaultMaxDate;
                    } else {
                        options['defaultDate'] = moment.toDate();
                    }
                } else {
                    options['defaultDate'] = moment.toDate();
                }
            }

            const picker = flatpickr(inputElements[i], options);
        }
    }

    function ConstrainedNumberInputs(input) {
        const value = parseFloat(input.value);
        const min = !!input.min ? parseFloat(input.min) : null;
        const max = !!input.max ? parseFloat(input.max) : null;
        const step = !!input.step ? parseFloat(input.step) : null;

        if (typeof min === 'number' && value < min) {
            input.value = min;
        } else if (typeof max === 'number' && value > max) {
            input.value = max;
        } else if (value % step > 0) {
            input.value = Math.round(Math.trunc((value + value % step) / step) * step * 100) / 100;
        }
    }

    function initConstrainedNumberInputs() {
        const inputElements = formElement.querySelectorAll('[type=number][min]:not([noinit]), [type=number][max]:not([noinit]), [type=number][step]:not([noinit])');

        for (let i = 0; i < inputElements.length; i++) {
            inputElements[i].addEventListener('change', function () {
                ConstrainedNumberInputs(this);
            });
        }
    }

    function initFilesInputs() {
        const inputElements = formElement.querySelectorAll('[type=file]');

        for (let i = 0; i < inputElements.length; i++) {
            let nextFilesListElement = formElement.querySelector('[data-files-list-for=' + inputElements[i].id + ']');

            if (!nextFilesListElement) {
                let nextElement = inputElements[i].nextElementSibling;

                while (nextElement) {
                    if (nextElement.nodeName === 'UL' && nextElement.hasAttribute('data-files-list')) {
                        nextFilesListElement = nextElement;
                        break;
                    }
                    nextElement = nextElement.nextElementSibling;
                }
            }

            if (nextFilesListElement) {
                inputElements[i].addEventListener('change', function (event) {

                    while (nextFilesListElement.firstChild) {
                        nextFilesListElement.removeChild(nextFilesListElement.firstChild);
                    }

                    for (let i = 0; i < this.files.length; i++) {
                        const item = document.createElement('li');

                        if (this.dataset.fileSizeLimit && this.files[i].size > parseFloat(this.dataset.fileSizeLimit) * 1048576) {
                            item.classList.add('error-alert');
                            item.innerHTML = '<i>' + this.files[i].name + '</i> est trop volumineux (> aux ' + this.dataset.fileSizeLimit + '&nbsp;Mo permis)';
                            event.preventDefault();
                        } else {
                            item.innerHTML = '<i>' + this.files[i].name + '</i>';
                        }

                        nextFilesListElement.append(item);
                    }
                });
            }
        }
    }

    function initDropdowns() {
        const dropdownElements = formElement.querySelectorAll('[data-dropdown]');

        for (let i = 0; i < dropdownElements.length; i++) {
            dropdowns.push(
                Dropdown(
                    {
                        selectElement: dropdownElements[i],
                        labelId: dropdownElements[i].dataset.labelId || null
                    }
                )
            );
        }
    }

    function initConditionalElements() {
        const conditionallyDisplayedElements = document.querySelectorAll('[data-display-if]');
        for (let i = 0; i < conditionallyDisplayedElements.length; i++) {
            ConditionallyDisplayedElement(conditionallyDisplayedElements[i]);
        }
    }

    function updateDropdownOptions(id, options) {
        const dropdown = dropdowns.filter(function(element) { return element.id == id; })[0];

        if (!!dropdown) {
            dropdown.updateOptions(options);
        }
    }

    function showDropdownSpinner(id) {
        const dropdown = dropdowns.filter(function(element) { return element.id == id; })[0];

        if (!!dropdown) {
            dropdown.showSpinner();
        }
    }

    function hideDropdownSpinner(id) {
        const dropdown = dropdowns.filter(function(element) { return element.id == id; })[0];

        if (!!dropdown) {
            dropdown.hideSpinner();
        }
    }

    initDateInputs();
    initConstrainedNumberInputs();
    initFilesInputs();
    initDropdowns();


    if (useDefaultSubmit == undefined || useDefaultSubmit === false) {
        const reCaptchaKeyInput = formElement.querySelector('[name="ReCaptchaKey"]');
        let reCaptchaTokenInputElement = null;

        if (reCaptchaKeyInput) {
            reCaptchaTokenInputElement = document.createElement('input');
            reCaptchaTokenInputElement.setAttribute('type', 'hidden');
            reCaptchaTokenInputElement.setAttribute('name', 'ReCaptchaToken');
            formElement.insertBefore(reCaptchaTokenInputElement, submitCTAElements[0]);
        }

        formElement.addEventListener('submit', function (event) {
            event.preventDefault();

            if (formElement.classList.contains('form')) {
                formElement.classList.toggle('form--already-submitted');
            }

            if (reCaptchaKeyInput) {
                executeRecaptcha(
                    reCaptchaKeyInput.value,
                    function (token) {
                        if (token.length) {
                            reCaptchaTokenInputElement.setAttribute('value', token);
                            if (params.submit) {
                                params.submit(event);
                            } else {
                                showSubmitCTASpinner();
                                formElement.submit();
                            }
                        }
                    },
                    function (message) {
                        const errorAlertElement = document.createElement('p');
                        errorAlertElement.classList.add('error-alert');
                        errorAlertElement.innerHTML = message;
                        formElement.insertBefore(errorAlertElement, submitCTAElements[0]);
                    });
            } else if (params.submit) {
                params.submit(event);
            } else {
                showSubmitCTASpinner();
                formElement.submit();
            }
        });
    }

    function showSubmitCTASpinner() {
        for (let i = 0; i < submitCTAElements.length; i++) {
            const submitCTAElement = submitCTAElements[i];

            if (submitCTAElement.classList.contains('cta') && !submitCTAElement.classList.contains(loadingCtaModifier)) {
                submitCTAElement.classList.add(loadingCtaModifier);
                submitCTAElement.setAttribute('disabled', 'disabled');
                const loaderElement = document.createElement('span');
                loaderElement.classList.add('loader');
                submitCTAElement.append(loaderElement);
            }
        }
    }

    function hideSubmitCTASpinner() {
        for (let i = 0; i < submitCTAElements.length; i++) {
            const submitCTAElement = submitCTAElements[i];

            if (submitCTAElement.classList.contains('cta') && submitCTAElement.classList.contains(loadingCtaModifier)) {
                submitCTAElement.classList.remove(loadingCtaModifier);
                submitCTAElement.removeAttribute('disabled');
                const loaderElement = submitCTAElement.querySelector('.loader');
                submitCTAElement.removeChild(loaderElement);
            }
        }
    }

    return {
        initConditionalElements: initConditionalElements,
        updateDropdownOptions: updateDropdownOptions,
        showDropdownSpinner: showDropdownSpinner,
        hideDropdownSpinner: hideDropdownSpinner,
        showSubmitCTASpinner: showSubmitCTASpinner,
        hideSubmitCTASpinner: hideSubmitCTASpinner
    }
}
